import React from 'react';
import { motion } from 'framer-motion';

const Header: React.FC = () => {
  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-white/95 backdrop-blur-sm border-b border-gray-100">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          <motion.div 
            className="flex items-center"
            initial={{ opacity: 0, x: -20 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.5 }}
          >
            <img 
              src="/kairos-logo.svg" 
              alt="Kairos AI" 
              className="h-8 w-auto"
            />
          </motion.div>
          
          <motion.nav 
            className="hidden md:flex items-center space-x-8"
            initial={{ opacity: 0, y: -10 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.2 }}
          >
            <a href="#core" className="text-sm font-medium text-slate-700 hover:text-blue-600 transition-colors">
              Kairos Core
            </a>
            <a href="#examples" className="text-sm font-medium text-slate-700 hover:text-blue-600 transition-colors">
              Examples
            </a>
            <a href="#why-different" className="text-sm font-medium text-slate-700 hover:text-blue-600 transition-colors">
              Why Kairos?
            </a>
            <button className="bg-gradient-to-r from-blue-600 to-emerald-600 text-white px-4 py-2 rounded-full text-sm font-medium hover:from-blue-700 hover:to-emerald-700 transition-all duration-300 shadow-lg hover:shadow-xl">
              Get Started
            </button>
          </motion.nav>
        </div>
      </div>
    </header>
  );
};

export default Header;